export const formatPlatterRolls = (rolls = []) =>
  rolls
    .filter((roll) => roll.quantity > 0)
    .map((roll) => `${roll.name} × ${roll.quantity}`);

export function PlatterDetails({ platter, compact = false }) {
  if (!platter) {
    return null;
  }

  const included = formatPlatterRolls(platter.included_rolls);
  const extras = formatPlatterRolls(platter.extra_rolls);

  return (
    <div
      className={compact ? "mt-1 space-y-0.5 text-xs text-neutral-500" : "mt-2 space-y-1 text-sm"}
      data-testid="platter-line-details"
    >
      {included.length > 0 && (
        <p data-testid="platter-included-rolls">Rolls: {included.join(", ")}</p>
      )}
      {platter.nigiri && (
        <p data-testid="platter-nigiri-detail">Nigiri: {platter.nigiri} (8 pieces)</p>
      )}
      {platter.sashimi && (
        <p data-testid="platter-sashimi-detail">Sashimi: {platter.sashimi} (8 pieces)</p>
      )}
      {extras.length > 0 && (
        <p data-testid="platter-extra-rolls-detail">
          Extra rolls: {extras.join(", ")}
          {platter.extra_total > 0 ? ` · $${platter.extra_total.toFixed(2)}` : ""}
        </p>
      )}
      <p data-testid="platter-line-total-pieces">Total pieces: {platter.total_pieces}</p>
    </div>
  );
}